module.exports = __webpack_public_path__ + "img/make-up.6bd151d0.svg";